var map = {
	"./errors.json": "./resources/js/localization/nl/errors.json",
	"./forms.json": "./resources/js/localization/nl/forms.json",
	"./sweepbright.json": "./resources/js/localization/nl/sweepbright.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/localization/nl sync \\.json$";